import { ISelectValues } from "./ISelectValues";

export const ID_FILTER_DATE_FROM_LM = "dateFrom";
export const ID_FILTER_DATE_TO_LM = "dateTo";
export const ID_FILTER_THRESHOLD_FROM_LM = "thresholdFrom";
export const ID_FILTER_THRESHOLD_TO_LM = "thresholdTo";
export const ID_FILTER_PERCENTAGE_FROM_LM = "percentageFrom";
export const ID_FILTER_PERCENTAGE_TO_LM = "percentageTo";
export const ID_FILTER_ACCRUED_FROM_LM = "accruedAmountFrom";
export const ID_FILTER_ACCRUED_TO_LM = "accruedAmountTo";
export const ID_FILTER_TYPOLOGY_LM = "typology";
export const ID_FILTER_CUSTOMERNAME_LM = "customerName";
export const ID_FILTER_SEARCH_LM = "search";
export const ID_FILTER_LEGAL_ENTITIES = "legal-entities";
export const ID_FILTER_DEALERS = "dealers";
export const transactionType: ISelectValues[] = [
  {
    value: "TAXABLE",
    label: "thresholds.types.taxable",
  },
  {
    value: "TIME_AND_KM",
    label: "thresholds.types.time&Km",
  }
];